export type SearchableSelectItem = {
  key: string;
  label: string;
  sectionName?: string;
};

/**
 * Narrows select options to those matching `query`, case-insensitively, on
 * either the option label or its section name — matching the section keeps a
 * whole category reachable by typing the category name. A blank query keeps
 * everything; keys in `alwaysVisibleKeys` are never filtered out.
 */
export function filterSelectItems<T extends SearchableSelectItem>(
  items: T[],
  query: string,
  alwaysVisibleKeys: string[] = [],
): T[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return items;

  return items.filter(
    (item) =>
      alwaysVisibleKeys.includes(item.key) ||
      item.label.toLowerCase().includes(normalizedQuery) ||
      (item.sectionName ?? "").toLowerCase().includes(normalizedQuery),
  );
}
